if (!customElements.get('teaser-hero')) {
  class TeaserHero extends HTMLElement {
    connectedCallback() {
      this.initVideos();
      this.initForm();
    }

    initVideos() {
      const videos = this.querySelectorAll('video[data-reveal]');

      videos.forEach(function (video) {
        function reveal() {
          video.classList.add('is-loaded');
        }

        if (video.readyState >= 2) {
          requestAnimationFrame(function () {
            reveal();
          });
        } else {
          video.addEventListener(
            'loadeddata',
            function () {
              requestAnimationFrame(function () {
                reveal();
              });
            },
            { once: true }
          );
        }
      });
    }

    initForm() {
      const form = this.querySelector('form[data-klaviyo-form]');
      const listId = this.dataset.listId;
      const companyId = this.dataset.companyId;

      if (!form || !listId) {
        return;
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        const emailInput = form.querySelector('input[type="email"]');
        const email = emailInput.value;
        const button = form.querySelector('button');
        const textEl = button.querySelector('[data-button-text]');
        const loaderEl = button.querySelector('[data-button-loader]');

        textEl.classList.add('invisible');
        loaderEl.classList.remove('hidden');
        button.disabled = true;

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website Hero',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId,
                },
              },
            },
          },
        };

        const endpoint =
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId;

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15',
          },
          body: JSON.stringify(payload),
        })
          .then(function (response) {
            if (response.ok || response.status === 202) {
              handleSuccess();
            } else {
              resetButton();
            }
          })
          .catch(function () {
            resetButton();
          });

        function handleSuccess() {
          emailInput.value = '';
          emailInput.blur();

          const wrapper = form.querySelector('[data-input-wrapper]');

          if (wrapper) {
            wrapper.classList.add('is-idle');
            wrapper.addEventListener(
              'mouseleave',
              function () {
                wrapper.classList.remove('is-idle');
              },
              { once: true }
            );
          }

          resetButton();

          const success = form.querySelector('[data-success]');

          if (success) {
            success.textContent = "Thank you! We'll be in touch";
            success.classList.remove('hidden');
            success.classList.add('fade-in');
          }
        }

        function resetButton() {
          textEl.classList.remove('invisible');
          loaderEl.classList.add('hidden');
          button.disabled = false;
        }
      });
    }
  }

  customElements.define('teaser-hero', TeaserHero);
}
